import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@mui/material';
import { Building, ClipboardExport, Eye, Location } from 'iconsax-react';
import { TableHeader } from '../../../../components/common/header/tableHeader/TableHeader';
import { SecondaryGrid } from '../../../../components/common/grid/SecondaryGrid';
import { palette } from '../../../../../theme/palette';
import { useAppSelector } from '@application/store/useStore';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
const theme = palette('light');
export const ClientTable = ({ searchQuery }) => {
    const { clients } = useAppSelector((state) => state.client);
    const navigate = useNavigate();
    const rows = useMemo(() => {
        return (clients || []).filter((clientItem) => clientItem?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            clientItem?.city?.toLowerCase().includes(searchQuery.toLowerCase()));
    }, [searchQuery, clients]);
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            renderHeader: () => _jsx(TableHeader, { icon: Building, text: ' Name' })
        },
        {
            field: 'city',
            headerName: 'Location',
            flex: 2,
            renderHeader: () => _jsx(TableHeader, { text: ' Location', icon: Location })
        },
        {
            field: 'edit',
            headerName: 'Edit',
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            renderHeader: () => _jsx(TableHeader, { text: 'Edit', icon: ClipboardExport }),
            renderCell: (params) => {
                const id = params.row.id;
                return (_jsx(IconButton, { onClick: () => navigate(`/clients-add-new?${new URLSearchParams({ id }).toString()}`), children: _jsx(Eye, {}) }));
            }
        }
    ];
    return (_jsx("div", { children: _jsx(SecondaryGrid, { columns: columns, rows: rows }) }));
};
